import angular from 'angular';
import _ from 'lodash';

angular.module('kiosk').controller('KioskPaymentSelectionCtrl', KioskPaymentSelectionCtrl);

KioskPaymentSelectionCtrl.$inject = ["$scope", "$state", "kioskSettings", "kioskUtils", "paymentMethods", "DigitalPaymentsManager", "alertDialog", "printerErrorFiscal", "$translate", "migrationHelper", "activeSalePayment", "entityManager"];

function KioskPaymentSelectionCtrl($scope, $state, kioskSettings, kioskUtils, paymentMethods, DigitalPaymentsManager, alertDialog, printerErrorFiscal, $translate, migrationHelper, activeSalePayment, entityManager) {
    const ActiveSale = migrationHelper.getActiveSale();

    var buttonTextColor = kioskSettings['general.base_button_text_color'] || '#fff';
    var buttonBackgroundColor = kioskSettings['general.base_button_bgcolor'] || '#666';
    var baseTextColor = kioskSettings['general.base_text_color'] || '#000';
    var zoomLevel = kioskSettings['general.zoom_level'] || 1.5;

    Object.assign($scope, {
        cardPayment: null,
        cashPayment: null,
        headerParams: {
            bannerUrl: kioskSettings['payment_selection.banner_url'],
            bannerBgColor: kioskSettings['general.header_background_color'],
            bannerHeight: kioskSettings['general.header_height'],
            logoUrl: _.toString(kioskSettings['general.media_url_logo']),
            zoomLevel: zoomLevel,
        },
        customerAssistantEnabled: kioskSettings['general.customer_assistant'],
        title: kioskUtils.getLabelText(kioskSettings, 'payment_selection.title_label','KIOSK.PAYMENT_SELECTION.TITLE'),
        totalLabel: kioskUtils.getLabelText(kioskSettings, 'cart.total_label', 'KIOSK.TOTAL'),
        backButtonLabel: kioskUtils.getLabelText(kioskSettings, 'general.back_button_label', 'KIOSK.BACK'),
        iconStyle: { color: buttonTextColor },
        buttonStyle: {
            color: buttonTextColor,
            'background-color': buttonBackgroundColor
        },
        paymentSelectionStyle: {
            'zoom': zoomLevel,
            color: baseTextColor
        },
        backgroundUrl: kioskSettings['payment_selection.background_url']
    });

    if($scope.backgroundUrl) {
        $scope.mediaType = kioskUtils.getMediaType($scope.backgroundUrl);
    }

    $scope.help = () => {
        // @toDO
        console.debug('AIUTO Da completare');
    };

    $scope.back = function() {
        $scope.$parent.enableTimeouts();
        $state.go(kioskUtils.getPreviousModule());
    };

    $scope.next = function() {
        $scope.$parent.enableTimeouts();
        $state.go(kioskUtils.getNextModule());
    };

    if(kioskSettings['payment_selection.default_cash_payment_id'] !== 'none') {
        $scope.cashPayment = kioskUtils.getAvailableCashPayments(paymentMethods, _.toInteger(kioskSettings['payment_selection.default_cash_payment_id']))[0];
    }

    if(kioskSettings['payment_selection.default_card_payment_id'] !== 'none') {
        $scope.cardPayment = kioskUtils.getAvailableCardPayments(paymentMethods, _.toInteger(kioskSettings['payment_selection.default_card_payment_id']))[0];
    }

    $scope.satispayPayment =  DigitalPaymentsManager.isPaymentDigitalEnvironmentAllowed(18) ? _.find(paymentMethods, { payment_method_type_id: 18 }) : null;
    $scope.prepaidPayment = _.find(paymentMethods, { payment_method_type_id: 16 });

    $scope.prepaidDisabled = false;
    $scope.prepaidVisible = false;
    $scope.payOnCashdeskEnabled = kioskSettings['payment_selection.enable_pay_on_cashdesk'] ? true : false;

    if($scope.prepaidPayment) {
        ActiveSale.checkPrepaidPaymentStatus($scope.prepaidPayment).then(function(result) {
            $scope.prepaidDisabled = result.$disabled;

            if(!result.$disabled) {
                var unclaimedPrepaid = _.find(paymentMethods, { payment_method_type_id: 16, unclaimed: true });
                var claimedPrepaid = _.find(paymentMethods, { payment_method_type_id: 16, unclaimed: false });

                $scope.prepaidVisible = unclaimedPrepaid && claimedPrepaid;
            } else {
                if(!result.customer_uuid) {
                    $scope.prepaidVisible = false;
                }
            }
        });
    }

    // CANCELED, CASHMATIC.CANCELED, CASHLOGY.CANCELED | abort text (ZVT)
    const CANCEL_PATTERN = /(^|\.)CANCELED$|Abort via timeout or abort-key/;

    const isCustomerCancel = (error) => {
        // Verifone Ocius rejects with { response: null, receiptData } when the customer cancels
        if(error?.response === null) {
            return true;
        }

        const code = error?.response ?? error;

        return !code || (typeof code === 'string' && CANCEL_PATTERN.test(code));
    };

    // Payments that went through (e.g. cash already collected) must not be retried from the payment screen.
    // Methods rolled back on print failure (Satispay, VNE) are never flagged as paid, but they carry their transaction data once charged
    const hasChargedPayments = () => !!ActiveSale.currentSale?.payments?.some((payment) => payment.paid === true
        || (payment.payment_data && DigitalPaymentsManager.paymentHasPrintFailRollback(payment.payment_method_type_id)));

    // Category printer overrides split the sale: items are removed from it and the charge can happen on a copy of the sale,
    // so after a failure the active sale does not tell whether the customer has been charged
    const saleUsesCategoryPrinters = async () => {
        const categories = await entityManager.categories.fetchCollectionOffline();
        const categoriesWithPrinter = new Set(categories.filter((category) => category.printer_id).map((category) => category.id));

        return !!ActiveSale.currentSale?.sale_items?.some((saleItem) => categoriesWithPrinter.has(saleItem.category_id));
    };

    // Disabled by default: the behaviour before TC-3905 (closable dialog, then standby, for every error)
    const requireOperatorOnPrintError = kioskSettings['payment_selection.require_operator_on_print_error'] ? true : false;

    // TC-4136: payment-step failures bring the customer back to the payment screen, post-payment ones (TC-3905) go to the standby
    var handleTransactionError = async (error, options) => {
        if(!requireOperatorOnPrintError) {
            alertDialog.show(printerErrorFiscal.translateError(error || 'CANCELED')).finally(() => {
                $state.go('app.kiosk.standby');
            });
            return;
        }

        // printDocument is the only source of array errors: the document failed to print, so the payment step is over
        const isPostPayment = options?.postPayment || Array.isArray(error) || hasChargedPayments();

        if(!isPostPayment) {
            // enableTimeouts is a no-op while a payment is in progress, and the flag is only reset after this handler runs
            $scope.$parent.paymentInProgress = false;

            if(isCustomerCancel(error)) {
                $scope.$parent.enableTimeouts();
                return;
            }

            console.error('Kiosk payment error', error);

            // the standby timer must not run while the dialog is open, or the dialog would stay on top of the standby screen
            alertDialog.show($translate.instant('KIOSK.PAYMENT_SELECTION.PAYMENT_ERROR')).finally(() => {
                $scope.$parent.enableTimeouts();
            });

            return;
        }

        if(error && error !== 'CANCELED') {
            // the customer only sees the generic message: keep the real cause for the operator
            console.error('Kiosk payment error', error);
            error = 'KIOSK.PAYMENT_SELECTION.PRINTER_ERROR';
        }

        const dialogConditions = error === 'CANCELED' ? {} : { showConfirmButton: false, isKioskShowed: true };

        alertDialog.show(printerErrorFiscal.translateError(error || 'CANCELED'), dialogConditions).finally(() => {
            $state.go('app.kiosk.standby');
        });
    };

    const performPayment = async (paymentMethod) => {
        $scope.$parent.paymentInProgress = true;
        $scope.$parent.disableTimeouts();

        ActiveSale.cleanPaymentsFromSale();

        let postPayment = false;

        try {
            // a failed sale split by category printers cannot be retried from the payment screen
            if(requireOperatorOnPrintError && await saleUsesCategoryPrinters()) {
                postPayment = true;
            }

            await ActiveSale.addGenericPayment(paymentMethod);

            const result = await activeSalePayment.emitSale({
                runSaleChecks: false,
                skipCashLimitCheck: true,
                skipReceiptOptions: true,
                hideResultNotes: true
            });

            // emitSale throws on failure: no emitted sale means it stopped after the payment (e.g. the sale could not be saved)
            if(!result?.emittedSale && !result?.splitHandled) {
                postPayment = true;
                throw result?.error || 'UNKNOWN_ERROR';
            }

            $scope.next();
        } catch(error) {
            handleTransactionError(error, { postPayment });
        } finally {
            $scope.$parent.paymentInProgress = false;
        }
    };

    $scope.payOnCashdesk = async () => {
        $scope.$parent.paymentInProgress = true;
        $scope.$parent.disableTimeouts();

        // a failed payment attempt leaves its unpaid payment on the sale, which must not be parked with it
        ActiveSale.cleanPaymentsFromSale();

        try {
            await ActiveSale.printNonFiscalSale();
            await ActiveSale.saveSale(null, true);

            $scope.next();
        } catch(error) {
            handleTransactionError(error, { postPayment: true });
        }

        $scope.$parent.paymentInProgress = false;
    };

    $scope.performDigitalPayment = function(paymentMethod) {
        performPayment(paymentMethod);
    };

    $scope.performPrepaidPayment = function() {
        if($scope.prepaidPayment) {
            $scope.performDigitalPayment($scope.prepaidPayment);
        }
    };

    $scope.payments = [
        {
            icons: ['assets/images/kiosk/payments_cash.svg'],
            label: $translate.instant('KIOSK.PAYMENT_SELECTION.CASH'),
            ariaLabel: 'Button cash payment',
            action: function() {
                $scope.performDigitalPayment($scope.cashPayment);
            },
            visible: $scope.cashPayment ? true : false
        },
        {
            icons: [
                'assets/images/kiosk/payments_card.svg',
                'assets/images/kiosk/contactless.svg'
            ],
            label: $translate.instant('KIOSK.PAYMENT_SELECTION.CREDIT_CARD'),
            ariaLabel: 'Button card payment',
            action: function() {
                $scope.performDigitalPayment($scope.cardPayment);
            },
            visible: $scope.cardPayment ? true : false
        },
        {
            icons: ['assets/images/kiosk/payments_satispay.svg'],
            label: $translate.instant('KIOSK.PAYMENT_SELECTION.SATISPAY'),
            ariaLabel: 'Button satispay payment',
            action: function() {
                $scope.performDigitalPayment($scope.satispayPayment);
            },
            visible: $scope.satispayPayment ? true : false
        },
        {
            icons: ['assets/images/kiosk/payments_prepaid.svg'],
            label: $translate.instant('KIOSK.PAYMENT_SELECTION.PREPAID'),
            ariaLabel: 'Button prepaid payment',
            action: function() {
                $scope.performPrepaidPayment();
            },
            get disabled() { return $scope.prepaidDisabled; },
            get visible() { return $scope.prepaidVisible; }
        },
        {
            icons: ['assets/images/kiosk/person.svg', 'assets/images/kiosk/payments_cashdesk.svg'],
            label: $translate.instant('KIOSK.PAYMENT_SELECTION.CASHDESK'),
            ariaLabel: 'Button pay on cashdesk payment',
            action: function() {
                $scope.payOnCashdesk();
            },
            visible: $scope.payOnCashdeskEnabled ? true : false
        }
    ];
}